var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21989 3.1001H15.6599C16.3399 3.1001 17.1899 3.5701 17.5499 4.1501L21.7299 10.8301C22.1299 11.4801 22.0899 12.5001 21.6299 13.1101L16.4499 20.0101C16.0799 20.5001 15.2799 20.9001 14.6699 20.9001H4.21989C2.46989 20.9001 1.40993 18.9801 2.32993 17.4901L5.09989 13.0601C5.46989 12.4701 5.46989 11.5101 5.09989 10.9201L2.32993 6.4901C1.40993 5.0201 2.47989 3.1001 4.21989 3.1001Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagRight);
export default ForwardRef;